export var Colors = {
  transparent: 'transparent',
  current: 'currentColor',
  black: '#000000',
  white: '#FFFFFF',
  grey: {
    50: '#F6F8F8',
    100: '#FCFCFC',
    250: '#F1F1F1',
    300: '#EAEAEA',
    400: '#DDDDDD',
    450: '#B9BEC3',
    800: '#71777E',
    950: '#373A3E',
    990: '#F4F8F8'
  },
  blue: {
    50: '#EDF5F8',
    100: '#ABD3FF',
    200: '#00CAFF',
    250: '#CEE2EC',
    275: '#0D4E8A',
    300: '#4CAAF0',
    600: '#0360A6',
    700: '#072C4D',
    1140: '#D4EEFF'
  },
  red: {
    25: '#FFFAFB',
    50: '#FFF5F6',
    400: '#8B0019',
    850: '#D11000',
    1000: '#FF0000'
  },
  green: {
    500: '#2B8022',
    700: '#48A63D',
    800: '#B3E264',
    850: '#246B1F',
    900: '#E6FFE6',
    950: '#1D581C'
  },
  orange: {
    550: '#FF8F00',
    700: '#F5A623'
  },
  purple: {
    600: '#7F3195'
  },
  yellow: {
    900: '#FFFDE3'
  }
};